import React from 'react'
import {SoldOutBodyMessage} from 'components/SearchUnavailability/SoldOut/SoldOutBodyMessage'

import {Button} from '@vio/atlas/Button'
import {Card} from '@vio/atlas/Card'
import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

interface Props {
  handleChangeDatesClick?: (event: React.MouseEvent) => void
}

export const RoomsSectionSoldOut: React.FC<Props> = ({
  handleChangeDatesClick
}) => {
  return (
    <Box paddingTop="s500">
      <Card
        borderRadius="lg"
        borderColorPath="border.neutral.secondary"
        dataId="roomsSectionSoldOut"
      >
        <Box
          paddingTop="s700"
          paddingBottom="s700"
          paddingRight="s600"
          paddingLeft="s600"
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap="s300"
          >
            <Box display="flex" gap="s200" alignItems="center">
              <Icon
                size="md"
                name="Forbid"
                colorPath="content.danger.secondary"
              />
              <Text variant="titleL">
                <FormattedMessageWrapper
                  id="unavailability.soldout"
                  defaultMessage="Sold out on your dates"
                />
              </Text>
            </Box>
            <Text>
              <SoldOutBodyMessage />
            </Text>
            {handleChangeDatesClick && (
              <Box paddingTop="s300">
                <Button
                  size="xl"
                  variant="tertiary"
                  onClick={handleChangeDatesClick}
                  dataId="roomsSectionSoldOutChangeDatesButton"
                >
                  <FormattedMessageWrapper
                    id="changeDates"
                    defaultMessage="Change dates"
                  />
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      </Card>
    </Box>
  )
}
